<script setup>
import { useDataStore } from '@/stores/data'
const dataStore = useDataStore()

defineProps({
	currentProcess: {
		type: Object,
		required: true,
	},
	visible: {
		type: Boolean,
		default: false,
	},
})
</script>

<template>
	<div class="progress-dialog" :class="{ visible }">
		<h2 class="mb-0">
			<template v-if="dataStore.processing"> Analyserer data... </template>
			<template v-if="dataStore.loadingSurvey && !dataStore.processing">{{ dataStore.currentProcess.process }}</template>
		</h2>
		<template v-if="dataStore.processing">
			<em>{{ dataStore.currentProcess.process }}</em>
		</template>
		<div class="progressbar">
			<div class="progress" :style="{ width: currentProcess.progress + '%', transitionDuration: currentProcess.progress < 10 ? '0s' : '0.5s' }"></div>
		</div>
	</div>
</template>

<style scoped>
.progress-dialog {
	position: absolute;
	top: 40%;
	left: 50%;
	width: 90vw;
	z-index: 9999;
	background-color: white;
	padding: 2rem;
	padding-bottom: 1.75rem;
	border-radius: 0.5rem;
	box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);
	opacity: 0;
	transition: all 0.5s ease-out;
	pointer-events: none;
	transform: translateX(-50%) translateY(-50vh);
}

.progress-dialog em {
	font-size: 0.75rem;
	opacity: 0.7;
	font-style: normal;
}

.progress-dialog.visible {
	transform: translateX(-50%) translateY(-50%);
	opacity: 1;
}

.progressbar {
	border-top-left-radius: 0.5rem;
	border-top-right-radius: 0.5rem;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 5px;
	background-color: rgba(0, 0, 0, 0.2);
}

.progress {
	border-top-left-radius: 0.5rem;
	border-top-right-radius: 0.5rem;
	width: 0%;
	height: 100%;
	background-color: #4caf50;
	transition: width 0.5s ease-out;
}

.duration {
	opacity: 0.6;
}
</style>
